import { ErrorText as ErrorMessage } from 'ui/formField';
import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { fontWeights, subtitle2, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledWarningBanner = styled(WarningBanner)`
  margin-bottom: ${spacing.threeQuarter};

  ul {
    padding-left: ${spacing.plusHalf};
    list-style-type: disc;
  }
`;

export const subtitle2Bold = {
  ...subtitle2,
  fontWeight: fontWeights.bold,
};

export const Subtitle2Bold = styled.h6(subtitle2Bold);

export const StyledValuesContainer = styled.div`
  display: flex !important;
  flex-direction: column !important;
  gap: ${pxToRem(5)};
`;

export const StyledValues = styled.div`
  margin-bottom: ${pxToRem(5)};
`;

export const RadioOptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const AttributePeriodRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const AttributePeriodRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const ErrorWrapper = styled.div`
  display: flex;
  margin-left: ${pxToRem(32)};
`;
export const ErrorText = styled(ErrorMessage)`
  margin: 0;
`;
